import template from './table.html';

class Table {
  constructor($sce, $timeout) {
    'ngInject';
    this.$sce = $sce;
    this.$timeout = $timeout;
    this.previousCheckIndex = -1;
  }

  checkClicked(event, item, index) {
    event.stopPropagation();
    this.$timeout(() => {
      if (item && this.previousCheckIndex !== -1 && event.shiftKey && item.checked) {
        let after = this.previousCheckIndex < index ? this.previousCheckIndex : index;
        let before = this.previousCheckIndex < index ? index : this.previousCheckIndex;

        this.list.forEach((item, itemIndex) => {
          if (itemIndex > after && itemIndex < before) {
            item.checked = true;
          }
        });
      }

      this.onCheckChange(item, index);
      this.previousCheckIndex = item?.checked ? index : -1;
    });
  }

  itemClicked(event, item, index) {
    // Timeout is need to make sure that the item checked variable has the updated value before calling onItemClick
    this.$timeout(() => {
      if (this.onItemClick) this.onItemClick(event, item, index);
    }, 0);
  }

  isBoolean(value) {
    return typeof value === 'boolean';
  }
}

export default {
  template,
  controller: Table,
  controllerAs: 'table',
  bindings: {
    list: '<',
    columns: '<',
    onItemClick: '<',
    onSortChange: '<',
    onCheckChange: '<',
    allChecked: '=',
    actionItems: '<',
    hasSelected: '<',
    searchString: '<',
  },
};
